// extracted by mini-css-extract-plugin
export var active = "anchors-nav-module--active--569ef";
export var anchorLine = "anchors-nav-module--anchorLine--a17b6";
export var anchorNav = "anchors-nav-module--anchorNav--273ee";
export var anchorText = "anchors-nav-module--anchorText--d5be9";
export var anchorTitle = "anchors-nav-module--anchorTitle--21985";